export default {
  updateHotels(state, payload) {
    state.hotels = payload
  },
  updateOrderedCountries(state, payload) {
    state.orderedCountries = payload
  },
  updateFilterCountriesList(state, payload) {
    state.filterCountriesList = payload
  },
  updateFilterHotelsList(state, payload) {
    state.filterHotelsList = payload
  },
  updateFilterCitiesList(state, payload) {
    state.filterCitiesList = payload
  },
  updateFilterDestination(state, payload) {
    state.filterDestination = payload
  },
  updateFilterOccupancy(state, payload) {
    state.filterOccupancy = payload
  },
  updateFilterDates(state, payload) {
    state.filterDates = payload
  },
  setPromotion(state, payload) {
    state.promotion = payload
  },
  setLoadingHotels(state, payload) {
    state.loadingHotels = payload
  },
  setValidateIdentity(state, payload) {
    state.validateIdentity = payload
  },
  updateFiltersCleared(state, payload) {
    state.filtersCleared = payload
  },
  setTmsDates(state, { bookingStartDate, bookingEndDate, reservationEndDate, reservationStartDate }) {
    state.tmsDates = {
      bookingStartDate,
      bookingEndDate,
      reservationEndDate,
      reservationStartDate
    }
  }
}
